<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ReceiptDetails')"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      config-module="1001008"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      @gridReady="params => gridApi = params.api"
    />
    <span slot="footer">
      <el-button @click="innerVisible = false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import StrUtils from '@/utils/StrUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { ensViewReceipts } from '@/api/seaExport/seaCargoDoc'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'EnsReceiptDetailsDialog',
  props: {
    pm: {
      type: Object,
      default: () => {}
    },
    visible: {
      type: Boolean,
      required: true
    },
    jobNo: {
      type: String,
      required: true
    },
    hblNbr2: {
      type: String,
      required: true
    },
    isChineseLanguage: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    tabName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      innerVisible: false,
      rowData: [],
      ensIsLink: false,
      amsIsLink: false,
      afrIsLink: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        rowHeight: 30,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('SeaExport.Hbl2'),
          colId: 'ams',
          field: 'ams',
          width: 255
        },
        {
          headerName: this.$t('SeaExport.ReceiptStatus'),
          colId: 'receiptCode',
          field: 'receiptCode',
          width: 255,
          cellRenderer: params => {
            if (StrUtils.isEmpty(params.value)) {
              return ''
            } else {
              return this.setCustomsStatusWithColor(params.value, this.isChineseLanguage)
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Describe'),
          colId: 'remark',
          field: 'remark',
          width: 255
        },
        {
          headerName: this.$t('SeaExport.Time'),
          colId: 'receiptDate',
          field: 'receiptDate',
          width: 255
        }
      ]
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
      await this.initData()
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    this.ensIsLink = cache.config.get('ENSSupplierConfiguration') === 'link'
    this.amsIsLink = cache.config.get('AMSInterfaceName') === 'link'
    this.afrIsLink = cache.config.get('afrSupplierConfiguration') === 'link'
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    async initData() {
      await ensViewReceipts({
        jobNo: this.jobNo,
        hblNbr2: this.hblNbr2,
        type: this.type
      }).then(res => {
        if (res.data) {
          this.rowData = res.data
        }
      })
    },
    setCustomsStatusWithColor(status, isCn) {
      let statusList
      if (this.tabName === 'ams' && this.amsIsLink) {
        statusList = SystemConstants.AMS_STATUS_LINK_LIST
      } else if (this.tabName === 'afr' && this.afrIsLink) {
        statusList = SystemConstants.AFR_STATUS_LINK_LIST
      } else if (this.tabName === 'ens' && this.ensIsLink) {
        statusList = SystemConstants.CUSTOMS_STATUS_LINK_LIST
      } else {
        statusList = SystemConstants.CUSTOMS_STATUS_LIST
      }
      for (const item of statusList) {
        if (item.code === status) {
          return `<span class="status-dot-${item.children}">${isCn ? item.chineseName : item.englishName}</span>`
        }
      }
      return status || ''
    }
  }
}
</script>

<style>
.status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}

.status-dot-green::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 15px;
  height: 15px;
  background-color: #2B7102;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.status-dot-red::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 15px;
  height: 15px;
  background-color: #E23426;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.status-dot-yellow::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 15px;
  height: 15px;
  background-color: #F9DF04;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.status-dot-gray::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 15px;
  height: 15px;
  background-color: #6F6F6F;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
  top: -2px;
}
</style>
